import React, { useState, useEffect } from 'react';
import Layout4 from "hocs/Layouts/Layout4";
import axios from 'axios';

function ValInsti() {
    const [nombre, setNombre] = useState('');
    const [dane, setDane] = useState('');
    const [codigoTerpel, setCodigoTerpel] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [departamento, setDepartamento] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Nuevo estado para eliminar
    const [idAEliminar, setIdAEliminar] = useState('');

    const handleDownloadExcel = () => {
        window.open(`${process.env.REACT_APP_API_URL}/ins/instiexcel/`, '_blank');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMensaje('');
        setError('');

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/ins/institutos/`, {
                nombre,
                DANE: Number(dane),
                terpel: Number(codigoTerpel),
                municipio,
                departamento
            });

            setMensaje('Institución creada con éxito.');
            setNombre('');
            setDane('');
            setCodigoTerpel('');
            setMunicipio('');
            setDepartamento('');
        } catch (err) {
            console.error(err);
            setError('Hubo un error al crear la institución.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (nombre || dane || codigoTerpel || municipio || departamento) {
            setMensaje('');
            setError('');
        }
    }, [nombre, dane, codigoTerpel, municipio, departamento]);

    return (
        <Layout4>

            {/* ================================
                SCROLL A LA IZQUIERDA
            ================================= */}
            <div
                style={{
                    direction: "rtl",
                    height: "90vh",
                    overflowY: "scroll",
                    paddingRight: "10px"
                }}
            >
                <div style={{ direction: "ltr" }}>
                    <div style={styles.container}>
                        <h1 style={styles.title}>Crear Institución Educativa</h1>

                        <form onSubmit={handleSubmit} style={styles.form}>
                            <label style={styles.label}>Nombre de la Institución</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                style={styles.input}
                                required
                            />

                            <label style={styles.label}>Código DANE</label>
                            <input
                                type="number"
                                value={dane}
                                onChange={(e) => setDane(e.target.value)}
                                style={styles.input}
                                required
                            />

                            <label style={styles.label}>Código Terpel</label>
                            <input
                                type="text"
                                value={codigoTerpel}
                                onChange={(e) => setCodigoTerpel(e.target.value)}
                                style={styles.input}
                                required
                            />

                            <label style={styles.label}>Municipio</label>
                            <input
                                type="text"
                                value={municipio}
                                onChange={(e) => setMunicipio(e.target.value)}
                                style={styles.input}
                                required
                            />

                            <label style={styles.label}>Departamento</label>
                            <input
                                type="text"
                                value={departamento}
                                onChange={(e) => setDepartamento(e.target.value)}
                                style={styles.input}
                                required
                            />

                            <button type="submit" style={styles.button} disabled={loading}>
                                {loading ? 'Creando...' : 'Crear Institución'}
                            </button>
                        </form>

                        {mensaje && <p style={styles.success}>{mensaje}</p>}
                        {error && <p style={styles.error}>{error}</p>}

                        <button
                            onClick={handleDownloadExcel}
                            style={{ ...styles.button, marginTop: '20px' }}
                        >
                            Descargar Excel de Instituciones
                        </button>

                        {/* =============================
                            SECCIÓN PARA ELIMINAR
                        ============================= */}
                        <h2 style={{
                            fontSize: "24px",
                            marginBottom: "20px",
                            marginTop: "40px",
                            color: "#333"
                        }}>
                            Eliminar Institución
                        </h2>

                        <input
                            type="text"
                            placeholder="ID de la institución"
                            value={idAEliminar}
                            onChange={(e) => setIdAEliminar(e.target.value)}
                            style={styles.input}
                        />

                        <button
                            onClick={async () => {
                                if (!idAEliminar.trim()) {
                                    setMensaje("⚠️ Ingresa un ID válido.");
                                    return;
                                }

                                const confirmacion = window.confirm(
                                    `¿Estás seguro de eliminar la institución con ID ${idAEliminar}?`
                                );
                                if (!confirmacion) return;

                                try {
                                    await axios.delete(`${process.env.REACT_APP_API_URL}/ins/institutos/${idAEliminar}/`);
                                    setMensaje("✅ Institución eliminada correctamente.");
                                    setIdAEliminar('');
                                } catch (err) {
                                    console.error(err);
                                    setMensaje("❌ No se pudo eliminar la institución.");
                                }
                            }}
                            style={{
                                backgroundColor: "#FF1E0A",
                                color: "white",
                                padding: "10px",
                                marginTop: "10px",
                                borderRadius: "5px",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            Eliminar institución
                        </button>
                    </div>
                </div>
            </div>

        </Layout4>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90vh',
        backgroundColor: '#F8F8F8',
        padding: '20px',
    },
    title: {
        color: '#1B8830',
        fontSize: '2rem',
        marginBottom: '20px',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        width: '300px',
    },
    label: {
        fontSize: '1rem',
        color: '#1B8830',
    },
    input: {
        padding: '10px',
        fontSize: '1rem',
        border: '1px solid #ccc',
        borderRadius: '5px',
    },
    button: {
        backgroundColor: '#1B8830',
        color: 'white',
        border: 'none',
        padding: '10px',
        fontSize: '1rem',
        cursor: 'pointer',
        borderRadius: '5px',
    },
    success: {
        marginTop: '20px',
        color: 'green',
        fontWeight: 'bold',
    },
    error: {
        marginTop: '20px',
        color: 'red',
        fontWeight: 'bold',
    },
};

export default ValInsti;